import React from 'react';
import AnswerMarkdown from '../AnswerMarkdown';
import { formatTokens } from '../../utils/askScope';

// The direct answer, larger and first in a turn (AC 70), rendered through AnswerMarkdown so no
// raw Markdown syntax shows (AC 65). Token chip bottom-right from usage.totalTokens (AC 77).
// `text` is the body to render: the answer, or the whole markdown for a legacy turn.
export default function AnswerCard({ text, usage, capHit, onRowRef }) {
  const chip = usage && typeof usage === 'object' ? formatTokens(usage.totalTokens) : '';
  const cap = capHit === true || (usage && usage.capHit === true);
  return (
    <div className="ask-answer">
      <div className="ask-answer-body">
        <AnswerMarkdown text={text} onRowRef={onRowRef} />
      </div>
      {chip ? <span className={`ask-token${cap ? ' chip--cap' : ''}`}>{chip}</span> : null}
    </div>
  );
}
